"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ExecutiveEndorsement() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="executive-endorsement" className="bg-background py-20 md:py-32 overflow-hidden">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl">
        <div ref={ref} className={`grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="relative max-w-md mx-auto lg:mx-0 lg:ml-auto w-full">
            {}
            <div className="absolute -bottom-6 -left-6 w-32 h-32 border-b-8 border-l-8 border-secondary rounded-bl-xl z-0"></div>
            
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580361/img/official_portrait_grayscale.png" alt="Tim Gordon - Executive Portrait" className="relative z-10 w-full h-auto aspect-[4/5] object-cover grayscale rounded-lg shadow-2xl" />
          </div>

          {}
          <div className="flex flex-col justify-center max-w-2xl">
            <h3 className="text-2xl md:text-3xl font-bold text-secondary mb-8 leading-tight tracking-tight">
              "Kanha ERP provides the institutional stability and innovation required for modern public administration."
            </h3>
            
            <blockquote className="text-lg text-foreground/90 font-sans mb-10 leading-relaxed">
              "The entire public sector is tired of fly-by-night fake solutions that fail after a year or two. Kanha ERP is time-tested, operates at a global scale, and continues to innovate year after year. I have seen Kanha ERP support all verticals from a single municipality to large-scale federal enterprises."
            </blockquote>
            
            <div className="flex flex-col">
              <span className="font-bold text-foreground text-xl">Thomas G.</span>
              <span className="text-muted-foreground text-sm uppercase tracking-widest mt-1 font-medium">
                Chief Information Officer, Department of Public Administration
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}